<template>
  <div class="px-md-0 px-3 container">
    <alert-message v-if="errorMessage"></alert-message>
    <div v-if = "CONSTANTS.MESSAGE_FOR_SUPPLIER_CENTRAL_DOWN.length>0" class="alert-container mb-2 pt-2" >
              <div class="fade-in-out alert alert-error" >
                <div><strong>{{CONSTANTS.MESSAGE_FOR_SUPPLIER_CENTRAL_DOWN}}</strong></div>
              </div>
            </div>
    <div v-if="!isLoading" class="row no-gutters mt-4">
      <div class="col-12 px-md-5 px-0 pb-5">
        <div class="mb-3">
          <div class="title-text section-title">Software</div>
          <p class="mt-3">
            The following is a list of commonly used software at Autodesk where no supplier central engagement form is required.  <br />
            Click the link provided for each software for specific purchasing instructions.
          </p>
          <div class="mt-2">
            Don’t see the software product you want? Please fill out an
            <a target="_self" href="/apps/supplier-central/supplier-guide#workWithSupplier" class="solution-link">engagement form
            </a>
            to ensure your purchase is compliant.
          </div>
        </div>
        <vue-good-table
          :columns="columns"
          :rows="filteredProducts"
          class="table-word-wrap"
          :pagination-options="{
            enabled: this.paginationEnabled,
            ...paginationOptions,
          }"
        >
          <div slot="emptystate">{{ noRecordsMesage }}</div>
          <template slot="table-column" slot-scope="props">
            <span v-if="props.column.label == 'Status'">
                <header-with-tooltip :tooltipText="softwareStatusTooltip"> {{props.column.label}} </header-with-tooltip>
            </span>
            <span v-else>
              {{props.column.label}}
            </span>
          </template>
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field === 'name'">
              <div class="content row-content">
                {{ props.row.name }}
              </div>
            </span>
            <span v-if="props.column.field === 'status'">
              {{props.row.status}}
            </span>

            <span v-if="props.column.field === 'vendorName'">
              <div class="content row-content">
                {{ props.row.vendorName }}
              </div>
            </span>

            <span v-if="props.column.field === 'actions'">
              <div class="content row-content">
                <p v-if="props.row.isPurchaseWithCard" class="purchase-with-card">
                   {{props.row.nextSteps}}
                </p>
                <span v-else-if=" props.row.status === CONSTANTS.COMPLAINT_NO_PERSONAL_DATA_STATUS && props.row.engagementUrl">
                  <a @click="openModal(props.row.engagementUrl,props.row.vendorId,props.row.nextSteps, props.row.name)" class="solution-link">{{props.row.displayText || props.row.nextSteps}}</a>
                </span>
                <a v-else-if="props.row.engagementUrl" target="_blank"  @click="props.row.displayText ? openModal(props.row.engagementUrl,props.row.vendorId,props.row.nextSteps, props.row.name) : engageProduct(props.row.engagementUrl)" class="solution-link">
                  {{props.row.displayText || props.row.nextSteps}}<font-awesome-icon class="ml-1" icon="external-link-alt" v-if="props.row.isExternalLink"/>
                </a>
                <span v-else>
                  <a @click="props.row.displayText ? openModal(props.row.engagementUrl,props.row.vendorId,props.row.nextSteps, props.row.name):launchOneIntakeForm(props.row.vendorId)" class="solution-link">{{props.row.displayText || props.row.nextSteps}}</a>
                </span>
              </div>
            </span>
          </template>
        </vue-good-table>
        <div class="support-section pl-2">
          <support></support>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VueGoodTable } from "vue-good-table";
import { mapGetters, mapActions } from "vuex";
import CONSTANTS from "@/store/constants";
import filter from "@/filters/filter";
import HeaderWithTooltip from "@/components/HeaderWithTooltip";
import Support from "@/components/Support"
import supplierRequestMixin from "@/mixins/supplierRequestMixin";
import AlertMessage from "@/components/AlertMessage";
import VGT_PAGINATION_OPTIONS from "../../store/vgtPaginationOptions";
import swal from "sweetalert2";

export default {
  name: "Software",
  components: {AlertMessage, HeaderWithTooltip, VueGoodTable, Support },
  mixins: [supplierRequestMixin],
  created() {
    if(!this.products || this.products.length === 0)
      this.fetchAllProducts()
  },
  beforeDestroy() {
    //Removing event listeners before the component is destroyed
    if( this.anchorOneIntake){
      this.anchorOneIntake.removeEventListener('click', this.launchOneIntakeForm);}
    if(this.anchorArticle){
      this.anchorArticle.removeEventListener('click', this.engageProduct);}
  },
  methods: {
    ...mapActions(["fetchAllProducts"]),
    engageProduct(engagementUrl) {
      engagementUrl = filter.updateUrlWithHttp(engagementUrl)
      let subEvent = `Engagement Url: ` + engagementUrl
      this.trackEvent("User engaged with supplier from Product List", subEvent)
      window.open(engagementUrl);
    },
     launchOneIntakeForm(id, productName = "") {
      let subEvent = `vendorId: `+id
      this.trackEvent("Engage with Supplier initiated",subEvent)
      this.$router.push({ name: "OneIntakeForm", query: {vendorId: id}, params: {productName : productName}});
    },
    openModal(engagementUrl,id,nextSteps, productName){
      swal.fire({
        title: `Re-direct`,
        allowEscapeKey: false,
        allowOutsideClick: false,
        showConfirmButton: false,
        showCancelButton: true,
        customClass: {
          cancelButton: "flat-btn primary-blue-btn cancel-btn btn mb-1"
        },
        html: this.htmlDataInModal(nextSteps),
      })
      this.$nextTick(() => {
        this.anchorOneIntake = document.getElementById('oneIntakeInstruction');
        this.anchorOneIntake.addEventListener('click', () => {
          this.launchOneIntakeForm(id,productName);
          swal.close();
        });
      });
      this.$nextTick(() => {
        this.anchorArticle = document.getElementById('reDirectionAnchor');
        this.anchorArticle.addEventListener('click', () => {
          this.engageProduct(engagementUrl);
          swal.close();
        });
      });
    },
    trackEvent(event, subEvent) {
      this.$hhMixpanel.trackEvent(event, {subEvent})
    },
    htmlDataInModal(nextSteps) {
      return `
         <p>You have selected a product in Supplier Central that meets security requirements but is not approved for privacy. Therefore no personal (customer or employee) data may be shared.</p>
         <p>If you plan to share personal data, please <a id="oneIntakeInstruction" target="_blank">submit a Supplier Central request</a> for the proper approvals, and make sure you answer ‘yes’ to questions related to sharing personal data. You will also need contact information for the supplier (name and email). </p>
          ${nextSteps !== CONSTANTS.ENGAGE_WITH_SUPPLIER ?
          `<p>If you do not plan to share personal data, ${nextSteps === CONSTANTS.PURCHASING_INSTRUCTIONS_NEXT_STEPS ?
              `please proceed to the <a id="reDirectionAnchor" target="_blank">purchasing instructions</a>.` :
              `please proceed to <a id="reDirectionAnchor" target="_blank">${nextSteps}</a>.`}</p>` :
          ''}
        <p>If you are unsure if personal data is being processed, you will want to share your specific use case with your legal business partner. </p>
  `;
    },
  },
  data() {
    return {
      noRecordsMesage: CONSTANTS.NO_PRODUCTS_MESSAGE,
      paginationOptions: VGT_PAGINATION_OPTIONS.PRODUCT_LIST_PAGINATION_OPTIONS,
      anchorOneIntake: null,
      anchorArticle: null,
    };
  },
  computed: {
    ...mapGetters(["products","isLoading","errorMessage"]),
    softwareStatusTooltip() {
      return `A software is <strong>Compliant</strong> if all the necessary security and privacy requirements are met and can be used for services. <br />
              <br /> A software is <strong>Compliant – No personal data</strong> if it meets security requirements but not privacy, therefore personal data may <strong>not</strong> be shared. <br />
              <br /> A software status is <strong>Pending agreement</strong> if the terms are currently being negotiated.<br />
              <br /> A software is <strong>Preferred</strong> if it is compliant as well as it has negotiated rates based on expected usage within Autodesk. <br />
              <br /> A software status is <strong>Unable to reach agreement</strong> if Autodesk and the supplier have not been able to agree on the terms.`
    },
    filteredProducts() {
      return this.getFilteredProducts(this.products)
    },
    paginationEnabled() {
      return this.filteredProducts.length > 15
    },
    columns() {
      return [
        {
          label: "Product name",
          field: "name",
          type: "string",
          thClass: "sorting",
          width: "33%",
        },
        {
          label: "Status",
          field: "status",
          type: "string",
          thClass: "hide-field-xs sorting",
          tdClass: "hide-field-xs status-field-text",
          width: "17%",
        },
        // {
        //   label: "Supplier name",
        //   field: "vendorName",
        //   type: "string",
        //   thClass: "hide-field-xs sorting",
        //   tdClass: "hide-field-xs",
        //   width: "25%",
        // },
        {
          label: "Next steps",
          field: "actions",
          thClass: "th-actions text-right",
          tdClass: "td-actions text-right",
          width: "25%",
          sortable: false,
        },
      ];
    },
  },
};
</script>

<style scoped>

.solution-link {
  word-wrap: break-word;
}

.purchase-with-card{
  word-wrap: break-word;
  margin-bottom: 0;
}

</style>
<style scoped src="@/assets/stylesheets/vgtStyles.css">
</style>